import { render, staticRenderFns } from "./SectionNotFound.vue?vue&type=template&id=336d4468&scoped=true&"
import script from "./SectionNotFound.vue?vue&type=script&lang=js&"
export * from "./SectionNotFound.vue?vue&type=script&lang=js&"
import style0 from "./SectionNotFound.vue?vue&type=style&index=0&id=336d4468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d4468",
  null
  
)

export default component.exports